import { useLayoutEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { useLive } from "../LiveProvider";

function LiveScrollRestoration() {
  const { sideBySideScrollPositionRef } = useLive();
  const sideBySideMatch = useRouteMatch("/live/:guid/comps");
  const listingMatch = useRouteMatch("/live/:guid/comps/listing/:id");
  const isSideBySide = sideBySideMatch && sideBySideMatch.isExact;
  const isListing = listingMatch && listingMatch.isExact;
  const reset = [!isSideBySide, !isListing].every(Boolean);

  useLayoutEffect(() => {
    if (reset) {
      sideBySideScrollPositionRef.current = 0;
    }
  }, [reset]);

  return null;
}

export default LiveScrollRestoration;
